export type DashController = {
  detach(): void;
};

export async function attachDash(video: HTMLVideoElement, src: string): Promise<DashController | null> {
  const mod = await import('dashjs').catch(() => null as any);
  if (!mod) return null;
  const dashjs = mod.default || mod;
  const player = dashjs.MediaPlayer().create();
  player.initialize(video, src, false);
  return {
    detach() {
      try {
        player.reset?.();
        player.detachView?.();
      } catch {}
    },
  };
}

